import queryString from 'query-string';
import http from '../httpConfig';
import { AddEditApi, List } from '../interfaces/property.interface';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';

const list = (payload: List) => {
  const { searchText, status, customerId, assignedTo, bookingType, city, myProperties, linked_with_hospitable, linkedWithHospitable, exclude, exclude_id, ...others } = payload as any;
  const paging = buildPagingResponse(others);
  const url = `${API_ENDPOINTS.listProperties}?${queryString.stringify({ ...paging, exclude, exclude_id })}`;

  return http.post(url, {
    search: searchText,
    is_active: status,
    customer_id: customerId,
    assigned_to: assignedTo,
    property_booking_type: bookingType,
    city: city,
    my_properties: myProperties,
    linked_with_hospitable: linked_with_hospitable,
  });
};

const kpis = () => {
  return http.get(API_ENDPOINTS.propertyKpis);
};

const add = (payload: AddEditApi) => {
  return http.post(API_ENDPOINTS.properties, payload);
};

const edit = (id: string, payload: AddEditApi) => {
  return http.put(`${API_ENDPOINTS.properties}/${id}`, payload);
};

const get = (id: string) => {
  return http.get(`${API_ENDPOINTS.properties}/${id}`);
};

const lookup = (payload: { searchText: string; exclude: string; exclude_id: string, is_active: string }) => {
  const url = `${API_ENDPOINTS.lookupProperties}?${queryString.stringify({ search: payload.searchText || '', exclude: payload.exclude, exclude_id: payload.exclude_id, is_active: payload.is_active })}`;
  return http.get(url);
};

const assignUser = (propertId: string, userId: string) => {
  return http.post(API_ENDPOINTS.assignRemoveUserProperty, { user_id: userId, property_id: propertId });
};

const removeUser = (id: string) => {
  return http.delete(`${API_ENDPOINTS.assignRemoveUserProperty}/${id}`);
};

const propertyUsers = (payload: List & { id: string, is_active?: string }) => {
  const { id, is_active, ...others } = payload as any;
  const paging = buildPagingResponse(others);
  const url = `${API_ENDPOINTS.propertyUsers}?${queryString.stringify({ ...paging, is_active })}`;
  return http.post(url, { property_id: id });
};

const PropertyService = { 
  list, 
  kpis, 
  add, 
  edit, 
  get, 
  lookup,
  assignUser,
  removeUser,
  propertyUsers
};

export default PropertyService;
